import { render, staticRenderFns } from "./LoadComponent.vue?vue&type=template&id=552e33ae&scoped=true"
import script from "./LoadComponent.vue?vue&type=script&lang=js"
export * from "./LoadComponent.vue?vue&type=script&lang=js"
import style0 from "./LoadComponent.vue?vue&type=style&index=0&id=552e33ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e33ae",
  null
  
)

export default component.exports